<template>
	<div class="certificate-query-result-page">
		<div class="top" v-if="isPC">
			<div></div>
			<div class="top_btn">
				<div class="btn1" @click="toBack">
					<img src="../assets/images/home1.png" alt="">
					<span>返回主页</span>
				</div>
				<div class="btn2" @click="toBack1">
					<img src="../assets/images/search1.png" alt="">
					<span>继续查询</span>
				</div>
			</div>
		</div>
		<div class="top1" v-if="!isPC">
			<div class="top_btn">
				<div class="btn1" @click="toBack">
					<img src="../assets/images/home1.png" alt="">
					<span>返回主页</span>
				</div>
				<div class="btn2" @click="toBack1">
					<img src="../assets/images/search1.png" alt="">
					<span>继续查询</span>
				</div>
			</div>
		</div>

		<!-- 证书卡片 -->
		<transition name="fade-slide-up">
			<div class="certificate-card">
				<!-- 卡片头部 -->
				<div class="card-header">
					<div class="header-content">
						<div>
							<h2 class="header-title">{{certificateData.type_parent_name}}查询结果报告</h2>
							<p class="query-time">查询时间: {{ currentTime }}</p>
						</div>
						<div class="header-icon">
							<img src="../assets/images/result-icon.png" alt="">
						</div>
					</div>
				</div>

				<!-- 卡片内容 -->
				<div class="card-body">
					<!-- 基本信息 -->
					<transition name="fade-in">
						<div class="info-section">
							<div class="section-title">
								<span class="title-bar"></span>
								<h3>企业基本信息</h3>
							</div>
							<div class="info-grid">
								<div class="info-item">
									<div class="icon-box">
										<img src="../assets/images/icon6.png" alt="">
									</div>
									<div>
										<p class="label">单位名称</p>
										<p class="value">{{ certificateData.is_daoqi == 1?'***':certificateData.name }}</p>
									</div>
								</div>
								<div class="info-item">
									<div class="icon-box">
										<img src="../assets/images/icon1.png" alt="">
									</div>
									<div>
										<p class="label">法定代表人</p>
										<p class="value">{{ certificateData.is_daoqi == 1?'***':certificateData.daibiao }}</p>
									</div>
								</div>
								<div class="info-item">
									<div class="icon-box">
										<img src="../assets/images/icon8.png" alt="">
									</div>
									<div>
										<p class="label">注册资金</p>
										<p class="value">{{ certificateData.is_daoqi == 1?'***':certificateData.money }}</p>
									</div>
								</div>
								<div class="info-item">
									<div class="icon-box">
										<img src="../assets/images/icon3.png" alt="">
									</div>
									<div>
										<p class="label">信用代码</p>
										<p class="value">{{ certificateData.is_daoqi == 1?'***':certificateData.code }}</p>
									</div>
								</div>
								<div class="info-item full-width">
									<div class="icon-box">
										<img src="../assets/images/icon9.png" alt="">
									</div>
									<div class="flex-row">
										<div>
											<p class="label">企业类型</p>
											<p class="value">{{ certificateData.is_daoqi == 1?'***':certificateData.hangye }}</p>
										</div>
									</div>
								</div>
								<div class="info-item full-width">
									<div class="icon-box">
										<img src="../assets/images/icon10.png" alt="">
									</div>
									<div class="flex-row">
										<div>
											<p class="label">注册地址</p>
											<p class="value">{{ certificateData.is_daoqi == 1?'***':certificateData.address }}</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</transition>

					<!-- 分割线 -->
					<div class="divider"></div>

					<!-- 认证信息 -->
					<transition name="fade-in">
						<div class="cert-section">
							<div class="section-title">
								<span class="title-bar"></span>
								<h3>证书信息</h3>
							</div>
							<div class="cert-content">
								<div class="cert-column">
									<div class="cert-fields">
										<div>
											<p class="label">证书类型</p>
											<p class="value">{{ certificateData.is_daoqi == 1?'***':certificateData.type_parent_name }}</p>
										</div>
										<div>
											<p class="label">证书名称</p>
											<p class="value">{{ certificateData.is_daoqi == 1?'***':certificateData.zs_name }}</p>
										</div>
									</div>
								</div>
								<div class="cert-column">
									<div class="cert-fields">
										<div>
											<p class="label">会员编号</p>
											<p class="value">{{ certificateData.is_daoqi == 1?'***':certificateData.number }}</p>
										</div>
										<div>
											<p class="label">会员有效期</p>
											<p class="value">{{ certificateData.is_daoqi == 1?'***':formattedDate(certificateData.end_time) }}</p>
										</div>
									</div>
								</div>
								<div class="cert-column">
									<div class="cert-fields">
										<div style="width: 100%;">
											<p class="label">发证单位意见</p>
											<p class="value">{{ certificateData.is_daoqi == 1?'***':certificateData.yijian }}</p>
										</div>
									</div>
								</div>
								<div class="cert-column">
									<div class="cert-fields">
										<div  style="width: 100%;">
											<p class="label">单位经营范围</p>
											<p class="value">{{ certificateData.is_daoqi == 1?'***':certificateData.fanwei }}</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</transition>

				</div>
			</div>
		</transition>
	</div>
</template>

<script>
	import {
		search_user,
	} from "@/api/index";
	export default {
		name: 'CertificateQueryResultPage',
		data() {
			return {
				certificateData: {},
				isPC: false,
				currentTime: '',
			};
		},
		mounted() {
			if (this.isMobile()) {
				this.isPC = false
			} else {
				this.isPC = true
			}
			let info = JSON.parse(sessionStorage.getItem('companyInfo'))

			let ajax = {
				type: info.type_id,
				name: info.name,
				code: info.code,
				number: info.number,
			}
			this.getDetail(ajax)
			this.getCurrentTime()
		},
		methods: {
			getCurrentTime() {
			  const now = new Date()
			  const year = now.getFullYear()
			  const month = String(now.getMonth() + 1).padStart(2, '0') // 月份从0开始，需+1
			  const day = String(now.getDate()).padStart(2, '0')
			  const hours = String(now.getHours()).padStart(2, '0')
			  const minutes = String(now.getMinutes()).padStart(2, '0')
			  const seconds = String(now.getSeconds()).padStart(2, '0')

			  this.currentTime = `${year}年${month}月${day}日 ${hours}:${minutes}:${seconds}`
			},
			formattedDate(data) {
			  if (typeof data === 'string' && /^\d{4}年\d{1,2}月\d{1,2}日$/.test(data)) {
			    return data;
			  }
			  const date = new Date(data);

			  // 检查是否是有效日期
			  if (isNaN(date.getTime())) {
			    console.warn('无效的日期格式:', data);
			    return data || ''; // 或返回原始值/空字符串
			  }

			  const year = date.getFullYear();
			  const month = (date.getMonth() + 1).toString().padStart(2, '0');
			  const day = date.getDate().toString().padStart(2, '0');

			  return `${year}年${month}月${day}日`;
			},
			getDetail(ajax) {
				search_user(ajax).then(res => {
					if (res.code == 1) {
						this.certificateData = res.data
					}
				})
			},
			isMobile() {
				const ua = navigator.userAgent;
				return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
			},
			toBack() {
				sessionStorage.removeItem('companyInfo')
				this.$router.push({
					path: '/',
					query: {}
				})
			},
			toBack1() {
				sessionStorage.removeItem('companyInfo')
				this.$router.go(-1)
			}
		}
	};
</script>

<style lang="scss" scoped>
	.certificate-query-result-page {
		min-height: 100vh;
		padding: 1.5rem 1rem;
		box-sizing: border-box;
		background-image: url("../assets/images/result-bg.png");
		background-repeat: no-repeat;
		background-size: cover;

		@media (min-width: 768px) {
			background-size: 100% 100%;
			padding: 3rem 1rem;
		}

		.top {
			position: absolute;
			right: 4rem;
			top: 3rem;
			display: flex;
			justify-content: flex-end;
			align-items: center;
			margin-bottom: 5rem;

			.logo {
				cursor: pointer;
			}
		}

		.top1 {
			width: calc(100% - 40px);
			display: flex;
			justify-content: flex-end;
			align-items: center;
			padding: 20px;
			position: relative;

			img {
				width: 100%;
			}
		}

		.top_btn {
			display: flex;
			align-items: center;

			.btn1 {
				margin-left: 10px;
				cursor: pointer;
				display: flex;
				align-items: center;

				img {
					width: 16px;
					height: 16px;
					margin-right: 4px;
				}
			}

			.btn2 {
				margin-left: 20px;
				cursor: pointer;
				display: flex;
				align-items: center;

				img {
					width: 16px;
					height: 16px;
					margin-right: 4px;
				}
			}
		}

		.certificate-card {
			max-width: 64rem;
			margin: 1rem auto 0;
			background: white;
			border-radius: 0.75rem;
			box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);

			@media (min-width: 768px) {
				margin: 4rem auto 0;
			}

			.card-header {
				background: linear-gradient(to right, #1d4ed8, #3b82f6);
				color: white;
				padding: 1.2rem;
				border-radius: 0.5rem 0.5rem 0 0;

				@media (min-width: 768px) {
					padding: 2rem;
					border-radius: 0.75rem 0.75rem 0 0;
				}

				.header-content {
					display: flex;
					justify-content: space-between;
					align-items: center;

					.header-title {
						font-size: 1.1rem;
						font-weight: 700;
						letter-spacing: .1rem;
					}

					@media (min-width: 768px) {
						font-size: 1.5rem;
					}

					.query-time {
						margin-top: .5rem;
						opacity: 0.9;
						font-size: 1rem;
					}

					.header-icon {
						opacity: 0.7;

						img {
							width: 2rem;
							height: 2rem;
						}

						@media (min-width: 768px) {
							img {
								width: 3rem;
								height: 3rem;
							}
						}
					}
				}
			}

			.card-body {
				padding: 1.5rem 1.5rem;

				@media (min-width: 768px) {
					padding: 1.5rem 2.5rem;
				}

				.info-section,
				.cert-section {
					//margin-bottom: 2rem;
				}

				.section-title {
					display: flex;
					align-items: center;
					margin-bottom: 1.5rem;

					.title-bar {
						height: 2rem;
						width: 0.25rem;
						background-color: #1d4ed8;
						margin-right: 0.75rem;
					}

					h3 {
						font-size: 1.25rem;
						font-weight: 700;
						color: #1f2937;
					}
				}

				.info-grid {
					display: grid;
					grid-template-columns: repeat(1, 1fr);
					gap: 1.3rem;

					@media (min-width: 768px) {
						grid-template-columns: repeat(2, 1fr);
					}

					.info-item {
						display: flex;
						padding: 1rem;
						background-color: #eff6ff;
						border: 1px solid #dbeafe;
						border-radius: 0.5rem;

						&.full-width {
							//grid-column: span 2;
						}

						.icon-box {
							background-color: #dbeafe;
							padding: 0.5rem;
							border-radius: 0.375rem;
							margin-right: 1rem;
							display: flex;
							align-items: center;
							justify-content: center;

							.icon {
								color: #1d4ed8;
								font-size: 1.25rem;
							}
						}

						.label {
							font-size: .8rem;
							color: #666;
						}

						.value {
							font-size: 1rem;
							font-weight: 500;
							margin-top: .2rem;
							color: #111;
						}

						.flex-row {
							display: flex;
							gap: 2rem;
						}
					}
				}

				.divider {
					height: 1px;
					background-color: #e5e7eb;
					margin: 2rem 0;
				}

				.cert-section {
					.cert-content {
						display: grid;
						grid-template-columns: 1fr;

						@media (min-width: 768px) {
							gap: 1.5rem;
						}

						.cert-column {
							&:nth-child(2) {
								.cert-fields {
									>div {
										&:last-child {
											margin-bottom: 0;
										}
									}
								}
							}

							.cert-header {
								display: flex;
								align-items: center;
								margin-bottom: 1.5rem;

								.icon {
									color: #1d4ed8;
									margin-right: 0.75rem;
									font-size: 1.5rem;
								}

								h4 {
									font-size: 1.125rem;
									font-weight: 600;
									color: #1f2937;
								}
							}

							.cert-fields {
								>div {
									margin-bottom: 1rem;

									.label {
										font-size: .8rem;
										color: #666;
									}

									.value {
										font-size: 1rem;
										font-weight: 500;
										margin-top: .2rem;
										color: #111;
									}
								}
							}

							@media (min-width: 768px) {
								.cert-fields {
									display: flex;

									>div {
										width: 50%;
										margin-bottom: 0;

										.label {
											font-size: .8rem;
											color: #666;
										}

										.value {
											font-size: 1rem;
											font-weight: 500;
											margin-top: .2rem;
											color: #111;
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}
</style>
